module.exports = __webpack_public_path__ + "static/media/photoTaskIcon.e57a8aeb.svg";